var map = {
	"./about.png": "93ce",
	"./atelier.png": "1772",
	"./bio.png": "4ff0",
	"./discord.png": "26da",
	"./gameboy.png": "3948",
	"./mail.png": "2f0a",
	"./photos.png": "c1f1",
	"./settings.png": "cc36",
	"./shop.png": "3140",
	"./tv.png": "d662",
	"./winamp.png": "7d54",
	"./world.png": "4760"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aada";